/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptTermsAndConditionsParams,
  CustomerProfileDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Update a customer profile with OTP verification
 * @summary Update profile with OTP
 */
export const updateProfileWithOtp = (
    customerProfileDTO: CustomerProfileDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerProfileDTO>(
      {url: `/api/frontend/admin/customer-profile/update-with-otp`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerProfileDTO
    },
      options);
    }
  


export const getUpdateProfileWithOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileWithOtp>>, TError,{data: CustomerProfileDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfileWithOtp>>, TError,{data: CustomerProfileDTO}, TContext> => {

const mutationKey = ['updateProfileWithOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfileWithOtp>>, {data: CustomerProfileDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateProfileWithOtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileWithOtpMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfileWithOtp>>>
    export type UpdateProfileWithOtpMutationBody = CustomerProfileDTO
    export type UpdateProfileWithOtpMutationError = unknown

    /**
 * @summary Update profile with OTP
 */
export const useUpdateProfileWithOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileWithOtp>>, TError,{data: CustomerProfileDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfileWithOtp>>,
        TError,
        {data: CustomerProfileDTO},
        TContext
      > => {

      const mutationOptions = getUpdateProfileWithOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get the customer profile for the currently authenticated user
 * @summary Get customer profile
 */
export const getCustomerProfile1 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerProfileDTO>(
      {url: `/api/frontend/admin/customer-profile`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomerProfile1InfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/admin/customer-profile`
    ] as const;
    }

export const getGetCustomerProfile1QueryKey = () => {
    return [
    `/api/frontend/admin/customer-profile`
    ] as const;
    }

    
export const getGetCustomerProfile1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerProfile1>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerProfile1InfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerProfile1>>> = ({ signal }) => getCustomerProfile1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerProfile1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerProfile1>>>
export type GetCustomerProfile1InfiniteQueryError = unknown


export function useGetCustomerProfile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerProfile1>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerProfile1>>,
          TError,
          Awaited<ReturnType<typeof getCustomerProfile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerProfile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerProfile1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerProfile1>>,
          TError,
          Awaited<ReturnType<typeof getCustomerProfile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerProfile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerProfile1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer profile
 */

export function useGetCustomerProfile1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerProfile1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerProfile1InfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerProfile1QueryOptions = <TData = Awaited<ReturnType<typeof getCustomerProfile1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerProfile1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerProfile1>>> = ({ signal }) => getCustomerProfile1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerProfile1QueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerProfile1>>>
export type GetCustomerProfile1QueryError = unknown


export function useGetCustomerProfile1<TData = Awaited<ReturnType<typeof getCustomerProfile1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerProfile1>>,
          TError,
          Awaited<ReturnType<typeof getCustomerProfile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerProfile1<TData = Awaited<ReturnType<typeof getCustomerProfile1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerProfile1>>,
          TError,
          Awaited<ReturnType<typeof getCustomerProfile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerProfile1<TData = Awaited<ReturnType<typeof getCustomerProfile1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer profile
 */

export function useGetCustomerProfile1<TData = Awaited<ReturnType<typeof getCustomerProfile1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerProfile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerProfile1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new customer profile
 * @summary Create profile
 */
export const createProfile = (
    customerProfileDTO: CustomerProfileDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerProfileDTO>(
      {url: `/api/frontend/admin/customer-profile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerProfileDTO, signal
    },
      options);
    }
  


export const getCreateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: CustomerProfileDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: CustomerProfileDTO}, TContext> => {

const mutationKey = ['createProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProfile>>, {data: CustomerProfileDTO}> = (props) => {
          const {data} = props ?? {};

          return  createProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createProfile>>>
    export type CreateProfileMutationBody = CustomerProfileDTO
    export type CreateProfileMutationError = unknown

    /**
 * @summary Create profile
 */
export const useCreateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProfile>>, TError,{data: CustomerProfileDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProfile>>,
        TError,
        {data: CustomerProfileDTO},
        TContext
      > => {

      const mutationOptions = getCreateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Send terms and conditions to the current user
 * @summary Send terms and conditions
 */
export const sendTermsAndConditions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/frontend/admin/customer-profile/send-terms`, method: 'POST', signal
    },
      options);
    }
  


export const getSendTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTermsAndConditions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendTermsAndConditions>>, TError,void, TContext> => {

const mutationKey = ['sendTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTermsAndConditions>>, void> = () => {
          

          return  sendTermsAndConditions(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof sendTermsAndConditions>>>
    
    export type SendTermsAndConditionsMutationError = unknown

    /**
 * @summary Send terms and conditions
 */
export const useSendTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTermsAndConditions>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendTermsAndConditions>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSendTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Send OTP for payment information change
 * @summary Send OTP for payment info change
 */
export const sendOtpForPaymentInfoChange = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/frontend/admin/customer-profile/send-otp-payment-info`, method: 'POST', signal
    },
      options);
    }
  


export const getSendOtpForPaymentInfoChangeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOtpForPaymentInfoChange>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendOtpForPaymentInfoChange>>, TError,void, TContext> => {

const mutationKey = ['sendOtpForPaymentInfoChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendOtpForPaymentInfoChange>>, void> = () => {
          

          return  sendOtpForPaymentInfoChange(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendOtpForPaymentInfoChangeMutationResult = NonNullable<Awaited<ReturnType<typeof sendOtpForPaymentInfoChange>>>
    
    export type SendOtpForPaymentInfoChangeMutationError = unknown

    /**
 * @summary Send OTP for payment info change
 */
export const useSendOtpForPaymentInfoChange = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendOtpForPaymentInfoChange>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendOtpForPaymentInfoChange>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSendOtpForPaymentInfoChangeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Accept terms and conditions with OTP verification
 * @summary Accept terms and conditions
 */
export const acceptTermsAndConditions = (
    params: AcceptTermsAndConditionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/frontend/admin/customer-profile/accept-terms`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getAcceptTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTermsAndConditions>>, TError,{params: AcceptTermsAndConditionsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTermsAndConditions>>, TError,{params: AcceptTermsAndConditionsParams}, TContext> => {

const mutationKey = ['acceptTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTermsAndConditions>>, {params: AcceptTermsAndConditionsParams}> = (props) => {
          const {params} = props ?? {};

          return  acceptTermsAndConditions(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTermsAndConditions>>>
    
    export type AcceptTermsAndConditionsMutationError = unknown

    /**
 * @summary Accept terms and conditions
 */
export const useAcceptTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTermsAndConditions>>, TError,{params: AcceptTermsAndConditionsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptTermsAndConditions>>,
        TError,
        {params: AcceptTermsAndConditionsParams},
        TContext
      > => {

      const mutationOptions = getAcceptTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    